import feedbacks from './feedbacks'
import feedback_replies from "./feedback_replies"
import inquiry_ratings from "./inquiry_ratings"
import faqs from "./faqs"
import faq_ratings from "./faq_ratings"
import nps from "./nps"
import search_nps from "./search_nps"
import chatbot from "./chatbot"

export default {
  feedbacks,
  feedback_replies,
  inquiry_ratings,
  faqs,
  faq_ratings,
  nps,
  search_nps,
  chatbot
}
